import intl from 'react-intl-universal';
import { searchSeries } from '@/api/systemSetting';
import { OldGoodType, SelectOldGoodFormType } from '@/type/components';
// import { WaterMark } from '@ant-design/pro-components';
import {
    ProForm,
    ProFormRadio,
    ProFormSelect,
    // WaterMark,
    ProFormDependency,
    ProFormInstance,
} from '@ant-design/pro-components';
import { message } from 'antd';
import { useState, useEffect, useRef } from 'react';
import ProductTableSelect from '../ProductTableSelect';
import UploadImage from '../upload';
import AftersaleReason from '../../../AftersaleReason';
import { debounce } from 'lodash';
import wtihWatermark from '@/layout/watermark';
import { OTHERVALUE } from '@/enum/afterSales';
import { default as ModalForm } from '@/components/CssModalForm';

type SelectOldProductProps = {
    value?: OldGoodType;
    onValueChange?: (value: OldGoodType) => void;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    showSameChange: boolean;
    aftersaleType: number;
    sessionId?: string;
};

const SelectOldProduct: React.FC<SelectOldProductProps> = ({
    value,
    onValueChange,
    open,
    onOpenChange,
    showSameChange,
    aftersaleType,
    sessionId,
}) => {
    const formRef = useRef<ProFormInstance>();

    // 系列名选项
    const [series, setSeries] = useState<string[]>([]);
    const [currentSeries, setCurrentSeries] = useState<string>();
    const [isCreat, setIsCreat] = useState(false);

    // 搜索系列名
    const seriesSearch = debounce((series: string) => {
        if (!series) {
            return;
        }
        searchSeries(series).then((result) => {
            if (result) {
                setSeries(result.map((item) => item.series_name));
            }
        });
    }, 500);

    // 系列名改变
    const seriesChange = (series: string) => {
        setCurrentSeries(series);

        formRef.current?.resetFields();
        formRef.current?.setFieldsValue({
            series,
        });
        setIsCreat(true);
    };

    // useEffect(() => {}, [value]);

    useEffect(() => {
        setCurrentSeries(value?.seriesName);
    }, []);

    useEffect(() => {
        if (value?.productName) {
            setIsCreat(false);
        } else {
            setIsCreat(true);
        }
    }, [value?.productName]);

    // 获取初始值
    const getInitValue = () => {
        if (value) {
            return {
                isSameChange: false,
                seriesName: value.seriesName,
                product: {
                    seriesName: value.seriesName,
                    productName: value.productName,
                    productCode: value.productCode,
                    productImage: value.productImage,
                },
                problemPos: value.problemPos,
                problemType: value.problemType,
                first_reasons: value.first_reasons?.map((i) => {
                    return {
                        label: i?.reason_value,
                        value: i?.reason_code,
                    };
                }),
                second_reasons: value.second_reasons?.map((i) => i.reason_code),
                problem_pos: value.problemPos,
                // 其他原因
                reason_other:
                    value.second_reasons?.find(
                        (i) => i.reason_code === OTHERVALUE,
                    )?.reason_value || undefined,
                aftersale_reason: {
                    first_reasons: value.first_reasons || [],
                    second_reasons: value.second_reasons || [],
                    problem_pos: value.problemPos,
                    reason_other:
                        value.second_reasons?.find(
                            (i) => i.reason_code === OTHERVALUE,
                        )?.reason_value || undefined,
                },
                images: value.images.map((item, index) => ({
                    uid: index,
                    thumbUrl: item,
                    url: item,
                    status: 'done',
                })),
            };
        }
        return { isSameChange: undefined };
    };

    const finishAction = (values: SelectOldGoodFormType) => {
        console.log('finishAction', values);
        // if (!values.product) {
        //     message.warning('请选择商品');
        //     return;
        // }
        // if (values?.aftersale_reason?.first_reasons?.length < 1) {
        //     message.warning('请选择售后原因');
        //     return;
        // }
        // if (values?.aftersale_reason?.second_reasons?.length < 1) {
        //     message.warning('请选择瑕疵原因');
        //     return;
        // }

        // if (values?.aftersale_reason?.problem_pos === undefined) {
        //     message.warning('请选择瑕疵部位');
        //     return;
        // }

        // if (!values.images || values.images.length < 1) {
        //     message.warning('请至少上传1张图片');
        //     return;
        // }
        if (
            values.images.find(
                (item) => item.status === 'error' || item.status !== 'done',
            )
        ) {
            message.warning(intl.get('请确保所有图片全部上传成功'));
            return;
        }
        // if (showSameChange && values.isSameChange === undefined) {
        //     message.warning('请选择是否 A 换 A');
        //     return;
        // }

        const oldGood: OldGoodType = {
            seriesName: values.product.seriesName,
            productCode: values.product.productCode,
            productImage: values.product.productImage,
            productName: values.product.productName,
            problemPos: values.aftersale_reason?.problem_pos,
            problemType: values.problemType,
            first_reasons: values.aftersale_reason?.first_reasons,
            second_reasons: values.aftersale_reason?.second_reasons,
            images: values.images.map((item) => item.url!),
            isSameChange: values.isSameChange,
        };

        if (onValueChange) {
            onValueChange(oldGood);
        }
    };

    return (
        <ModalForm<SelectOldGoodFormType>
            modalProps={{
                destroyOnClose: true,
                maskClosable: false,
            }}
            formRef={formRef}
            layout="horizontal"
            labelWrap={true}
            // grid={true}
            title={intl.get('选择旧商品')}
            open={open}
            onOpenChange={onOpenChange}
            initialValues={getInitValue()}
            onFinish={finishAction}
        >
            <ProFormSelect
                label={intl.get('系列名称')}
                name="series"
                // colProps={{
                //     span: 24,
                // }}
                fieldProps={{
                    showSearch: true,
                    showArrow: false,
                    filterOption: false,
                    options: series.map((item) => ({
                        value: item,
                        label: item,
                        title: item,
                    })),
                    onSearch: seriesSearch,
                    onChange: seriesChange,
                }}
            />

            <ProForm.Item name="product">
                <ProductTableSelect
                    series={currentSeries || ''}
                    value={isCreat ? {} : value}
                />
            </ProForm.Item>
            <ProFormDependency name={['product']}>
                {({ product }) => {
                    if (product?.productCode) {
                        return (
                            <ProForm.Item name="aftersale_reason">
                                <AftersaleReason
                                    fieldName="aftersale_reason"
                                    isCreat={isCreat}
                                    product_code={product.productCode}
                                    aftersale_type={aftersaleType}
                                ></AftersaleReason>
                            </ProForm.Item>
                        );
                    }
                    return '';
                }}
            </ProFormDependency>

            <ProForm.Item
                name="images"
                required={true}
                label={intl.get('上传凭证(1~9张图片)')}
                rules={[
                    {
                        required: true,
                        message: intl.get('请上传凭证'),
                    },
                ]}
                // colProps={{
                //     span: 20,
                // }}
            >
                <UploadImage
                    accept="image/*"
                    maxCount={9}
                    sessionId={sessionId}
                />
            </ProForm.Item>

            {showSameChange ? (
                <ProFormRadio.Group
                    name="isSameChange"
                    label={intl.get('是否A换A')}
                    required={true}
                    colProps={{
                        span: 20,
                    }}
                    options={[
                        {
                            label: intl.get('是'),
                            value: true,
                        },
                        {
                            label: intl.get('否'),
                            value: false,
                        },
                    ]}
                    rules={[
                        {
                            required: true,
                            message: intl.get('请选择是否A换A'),
                        },
                    ]}
                />
            ) : null}
        </ModalForm>
    );
};

export default wtihWatermark(SelectOldProduct, {
    zIndex: 9999,
    fontColor: '#bbb',
    markStyle: {
        position: 'fixed',
        height: '100vh',
        width: '100vw',
        opacity: 0.3,
    },
});
